import React from "react";
import { Header } from "../../components/ui/Header";
import MarginNew from "./MarginNew";



const Margin = () => {

  return (
    <div className="flex flex-col relative">
      <Header />
      <MarginNew/>
    </div>
  );
};

export default Margin;